import { MATRIX_ROOMS_PAGE_LIMIT } from '../../../../shared/constants/message';
import { getMatrixRoomsArray } from '../../../../shared/utils/chatUtil';

export function normalizeMatrixRoomsPayload(response) {
  const raw = response?.status === 204
    ? { rooms: [] }
    : (Array.isArray(response?.data)
      ? { rooms: response.data }
      : (response?.data || { rooms: [] }));

  const rooms = Array.isArray(raw.rooms) ? raw.rooms : [];
  const page = typeof raw.page === 'number' ? raw.page : 1;
  const limit = typeof raw.limit === 'number' && raw.limit > 0
    ? raw.limit
    : MATRIX_ROOMS_PAGE_LIMIT;
  const total = typeof raw.total === 'number' ? raw.total : rooms.length;
  const count = typeof raw.count === 'number' ? raw.count : rooms.length;

  return { rooms, page, limit, total, count };
}

export function computeMatrixRoomsHasMore({ page, limit, total, count }) {
  if (!limit || limit <= 0) return false;
  if (typeof total === 'number' && total >= 0) {
    return page * limit < total;
  }
  return count >= limit;
}

/** Recompute hasMore from how many room rows are already in Redux vs backend total. */
export function computePaginationAfterRefreshMerge(existingPagination, incomingPagination, mergedRoomsPayload) {
  const loadedCount = getMatrixRoomsArray(mergedRoomsPayload).length;
  const total = incomingPagination?.total ?? existingPagination?.total ?? loadedCount;
  const page = Math.max(
    existingPagination?.page || 0,
    incomingPagination?.page || 1,
  );

  return {
    page,
    total,
    hasMore: loadedCount < total,
  };
}
